import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducers } from '../jobseeker-store/reducer';
import { EffectsModule } from '@ngrx/effects';
import { JobseekerProfileEffects } from './jobseeker-profile';
import { JobseekerProfileForAdminEffects } from './jobseeeker-profile-for-admin';
import { JobseekerEffects } from './effects';
import { JobseekerRegistrationEffects } from './jobseeker-registration';
import { JobseekerSettingsEffects } from './jobseeker-settings';
import { JobseekerSubscriptionEffects } from './jobseeker-subscription'
import { JobseekerResetPasswordEffects } from './reset-password';
import { JobseekerAppliesEffects } from './jobseeker-applies';
import { SpecializationEffects } from './jobseeker-specialization';
import { IndustryEffects } from './jobseeker-industry';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('jobseeker',  reducers),
    EffectsModule.forFeature([JobseekerEffects, 
                              JobseekerProfileEffects.JobseekerProfileEffects,
                              JobseekerProfileForAdminEffects.JobseekerProfileForAdminEffects,
                              JobseekerRegistrationEffects.JobseekerRegistrationEffects,
                              JobseekerSettingsEffects.JobseekerSettingsEffects,
                              JobseekerResetPasswordEffects.JobseekerResetPasswordEffects,
                              JobseekerSubscriptionEffects.JobseekerSubscriptionEffects,
                              JobseekerAppliesEffects.JobseekerAppliesEffects,
                              SpecializationEffects.SpecializationEffects,
                              IndustryEffects.IndustryEffects
                            ])
  ]
})
export class JobseekerStoreModule { }
